import { mediaImg } from '@/components/imageConstants';

export function chargerImageUrl(src, width = 1200) {
  return mediaImg(src, width);
}

export default function chargerGalleryImages(charger, en = false) {
  const photos = [...(charger.gallery_images || [])];
  if (charger.lifestyle_image && !photos.some(p => p.url === charger.lifestyle_image)) photos.unshift({ url: charger.lifestyle_image });
  if (charger.image && !photos.some(p => p.url === charger.image)) photos.push({ url: charger.image, product: true });
  return photos.filter(p => p.url).map((p, i) => ({
    ...p,
    alt: en ? `${charger.name} · ${p.product ? 'product photo' : `manufacturer photo ${i + 1}`}` : p.alt || `${charger.name} · ${p.product ? 'produktfoto' : `producentfoto ${i + 1}`}`,
    caption: en ? `${charger.name} · ${p.product ? 'Product view' : `Installation photo ${i + 1}`} · ${charger.brand || ''}` : p.caption || `${charger.name} · ${p.product ? 'Produktfoto' : 'Producentfoto'}`,
  }));
}